import React from "react";
import { Controller } from "react-hook-form";

//UI
import { Button, Row, Col, Checkbox, Form } from "antd";
import moment from "moment";
import {
  DatePicker,
  InputNumber,
  Input,
  TextArea,
} from "../../Common/Input/index";
import { RequiredFormLabel } from "../RequiredFormLabel/RequiredFormLabel";
import TimeZoneSelect from "../TimeZoneSelect/TimeZoneSelect";

//processing
import {
  SOLUTION_OPTIONS,
  RECORD_OPERATIONS,
  ONBOARDING_CORPORATE_CONTACT_STATUS,
} from "../../../utils/onboarding-helper";

import "./styles.css";

const solutonOptions = [
  {
    label: SOLUTION_OPTIONS.MYDOCS_WITH_SIGNATURE,
    value: SOLUTION_OPTIONS.MYDOCS_WITH_SIGNATURE,
  },
  {
    label: SOLUTION_OPTIONS.MYDOCS_WITHOUT_SIGNATURE,
    value: SOLUTION_OPTIONS.MYDOCS_WITHOUT_SIGNATURE,
  },
];

const CustomerDetailsForm = (props) => {
  const { control, errors, operation, getValues } = props;

  return (
    <div>
      <Form layout="vertical" className="onboarding-form">
        <Row gutter={8}>
          {/* Customer details Col1 */}
          <Col span={8}>
            <Form.Item
              label={<RequiredFormLabel value="Customer Name (HMG)" />}
              help={errors?.customer_name?.message}
              validateStatus={errors?.customer_name ? "error" : ""}
            >
              <Controller
                control={control}
                name="customer_name"
                render={({ field: { onChange, value } }) => (
                  <Input
                    value={value}
                    onChange={onChange}
                    placeholder="Customer Name (HMG)"
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              label={<RequiredFormLabel value="Project Overview" />}
              help={errors?.project_overview?.message}
              validateStatus={errors?.project_overview ? "error" : ""}
            >
              <Controller
                control={control}
                name="project_overview"
                render={({ field: { onChange, value } }) => (
                  <TextArea
                    value={value}
                    onChange={onChange}
                    style={{ height: "109px" }}
                    placeholder="Project Overview"
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              label={<RequiredFormLabel value="Address Line 1" />}
              help={errors?.address_line_1?.message}
              validateStatus={errors?.address_line_1 ? "error" : ""}
            >
              <Controller
                control={control}
                name="address_line_1"
                render={({ field: { onChange, value } }) => (
                  <Input
                    value={value}
                    onChange={onChange}
                    placeholder="Address Line 1"
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              label={<RequiredFormLabel value="Address Line 2" />}
              help={errors?.address_line_2?.message}
              validateStatus={errors?.address_line_2 ? "error" : ""}
            >
              <Controller
                control={control}
                name="address_line_2"
                render={({ field: { onChange, value } }) => (
                  <Input
                    value={value}
                    onChange={onChange}
                    placeholder="Address Line 2"
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              label={<RequiredFormLabel value="City" />}
              help={errors?.city?.message}
              validateStatus={errors?.city ? "error" : ""}
            >
              <Controller
                control={control}
                name="city"
                render={({ field: { onChange, value } }) => (
                  <Input value={value} onChange={onChange} placeholder="City" />
                )}
              />
            </Form.Item>
          </Col>
          {/* Customer Details Col 2 */}
          <Col span={8}>
            <Form.Item
              label={<RequiredFormLabel value="State" />}
              help={errors?.state?.message}
              validateStatus={errors?.state ? "error" : ""}
            >
              <Controller
                control={control}
                name="state"
                render={({ field: { onChange, value } }) => (
                  <Input
                    value={value}
                    onChange={onChange}
                    placeholder="State"
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              label={<RequiredFormLabel value="Country" />}
              help={errors?.country?.message}
              validateStatus={errors?.country ? "error" : ""}
            >
              <Controller
                control={control}
                name="country"
                render={({ field: { onChange, value } }) => (
                  <Input
                    value={value}
                    onChange={onChange}
                    placeholder="Country"
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              label={<RequiredFormLabel value="Zip Code" />}
              help={errors?.zip_code?.message}
              validateStatus={errors?.zip_code ? "error" : ""}
            >
              <Controller
                control={control}
                name="zip_code"
                render={({ field: { onChange, value } }) => (
                  <Input
                    value={value}
                    onChange={onChange}
                    placeholder="Zip Code"
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              label={<RequiredFormLabel value="Time Zone" />}
              help={errors?.time_zone?.message}
              validateStatus={errors?.time_zone ? "error" : ""}
            >
              <Controller
                control={control}
                name="time_zone"
                render={({ field: { onChange, value } }) => (
                  <TimeZoneSelect
                    value={value}
                    onChange={onChange}
                    placeholder="Time Zone"
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              label={<RequiredFormLabel value="Contract Date" />}
              help={errors?.contract_date?.message}
              validateStatus={errors?.contract_date ? "error" : ""}
            >
              <Controller
                control={control}
                name="contract_date"
                render={({ field: { onChange, value } }) => (
                  <DatePicker
                    value={value ? moment(value) : undefined}
                    onChange={(e) => {
                      let newValue;
                      if (e) {
                        newValue = e.toISOString();
                      }
                      onChange(newValue);
                    }}
                    placeholder="Contract Date"
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              label={<RequiredFormLabel value="Effective Date" />}
              help={errors?.effective_date?.message}
              validateStatus={errors?.effective_date ? "error" : ""}
            >
              <Controller
                control={control}
                name="effective_date"
                render={({ field: { onChange, value } }) => (
                  <DatePicker
                    value={value ? moment(value) : undefined}
                    onChange={(e) => {
                      let newValue;
                      if (e) {
                        newValue = e.toISOString();
                      }
                      onChange(newValue);
                    }}
                    placeholder="Effective Date"
                  />
                )}
              />
            </Form.Item>
          </Col>
          {/* Customer Details Col 3 */}
          <Col span={8}>
            <Form.Item
              label={<RequiredFormLabel value="Solution" />}
              help={errors?.solution?.message}
              validateStatus={errors?.solution ? "error" : ""}
            >
              <Controller
                control={control}
                name="solution"
                render={({ field: { onChange, value } }) => (
                  <Checkbox.Group
                    options={solutonOptions}
                    onChange={(e) => {
                      let newValue = e[0];
                      if (e.length > 1) {
                        newValue = e[0] === value ? e[1] : e[0];
                      }
                      onChange(newValue);
                    }}
                    value={value ? [value] : []}
                    style={{ paddingBottom: "9.58px" }}
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              label={<RequiredFormLabel value="Corporate Contact First Name" />}
              help={errors?.corporate_contact_id?.first_name?.message}
              validateStatus={
                errors?.corporate_contact_id?.first_name ? "error" : ""
              }
            >
              <Controller
                control={control}
                name="corporate_contact_id.first_name"
                render={({ field: { onChange, value } }) => (
                  <Input
                    value={value}
                    onChange={onChange}
                    placeholder="Corporate Contact First Name"
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              label={<RequiredFormLabel value="Corporate Contact Last Name" />}
              help={errors?.corporate_contact_id?.last_name?.message}
              validateStatus={
                errors?.corporate_contact_id?.last_name ? "error" : ""
              }
            >
              <Controller
                control={control}
                name="corporate_contact_id.last_name"
                render={({ field: { onChange, value } }) => (
                  <Input
                    value={value}
                    onChange={onChange}
                    placeholder="Corporate Contact Last Name"
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              label={
                <RequiredFormLabel value="Corporate Contact Phone Number" />
              }
              help={errors?.corporate_contact_id?.phone_number?.message}
              validateStatus={
                errors?.corporate_contact_id?.phone_number ? "error" : ""
              }
            >
              <Controller
                control={control}
                name="corporate_contact_id.phone_number"
                render={({ field: { onChange, value } }) => (
                  <Input
                    value={value}
                    onChange={onChange}
                    placeholder="Corporate Contact Phone Number"
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              label={<RequiredFormLabel value="Corporate Contact Email" />}
              help={errors?.corporate_contact_id?.email?.message}
              validateStatus={
                errors?.corporate_contact_id?.email ? "error" : ""
              }
            >
              <Controller
                control={control}
                name="corporate_contact_id.email"
                render={({ field: { onChange, value } }) => (
                  <Input
                    value={value}
                    onChange={onChange}
                    disabled={
                      operation === RECORD_OPERATIONS.APPROVE ||
                      (operation === RECORD_OPERATIONS.EDIT &&
                        getValues("corporate_contact.status") !==
                          ONBOARDING_CORPORATE_CONTACT_STATUS.IN_DRAFT)
                    }
                    placeholder="Corporate Contact Email"
                  />
                )}
              />
            </Form.Item>
            <Form.Item
              label={<RequiredFormLabel value="Number of Properties" />}
              help={errors?.number_of_properties?.message}
              validateStatus={errors?.number_of_properties ? "error" : ""}
            >
              <Controller
                control={control}
                name="number_of_properties"
                render={({ field: { onChange, value } }) => (
                  <InputNumber
                    value={value}
                    onChange={onChange}
                    min={1}
                    className="full-width"
                    placeholder="Number of Properties"
                  />
                )}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CustomerDetailsForm;
